module.exports = "https://static.energy5.com/_next/static/images/rss-a3a0fdb2f8d085846f2a08caf6bb73d0.png";